<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.segmentos.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.configuracaoRastreabilidade.segmentos.novo")',
        :exibeBotao='true',
        @btnHeaderClicado='goToCadastroSegmento'
    )
    .bloco-segmentos
        .bloco-input
            .bloco-input__icon
                i.el-icon-search
            .bloco-input__input
                input.input-search(
                    v-model='query',
                    type='text',
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.segmentos.busca")',
                    autocomplete='off',
                    @keyup.enter='mudarPagina(1)'
                )
        .bloco-listagem-segmentos
            h3 {{ $t('mensagens.configuracaoRastreabilidade.segmentos.listagem') }}
            el-table(:key="listagemTableKey('segmentos', listaSegmentos, paginacao.pagina + 1)", :data='listaSegmentos')
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.configuracaoRastreabilidade.segmentos.tabela.nome")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '' }} {{ ' - ' }} {{ scope.row.codigo || '' }}
                el-empty(
                    :description='$t("mensagens.configuracaoRastreabilidade.segmentos.semDados")'
                )
            .bloco-paginacao
                span {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.configuracaoRastreabilidade.segmentos.segmentos') : $t('mensagens.configuracaoRastreabilidade.segmentos.segmento') }}
                el-pagination(
                    background,
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    layout='prev, pager, next',
                    :total='paginacao.total',
                    @current-change='mudarPagina'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import formatters from '@/utils/formatters';
import ConfiguracaoSegmentosService from '@/services/ConfiguracaoSegmentosService';

export default {
    name: 'ConfiguracaoSegmentos',
    components: {
        BaseHeader
    },
    data() {
        return {
            query: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            listaSegmentos: [],
            paginacao: {}
        };
    },
    mounted() {
        this.buscarSegmentos();
    },
    methods: {
        getFiltros() {
            const filtro = {};
            filtro.page = this.pageable.page - 1;
            filtro.size = this.pageable.size;
            filtro.filtro = this.query || '';
            filtro.order = '&sort=nome,asc';
            return filtro;
        },

        async buscarSegmentos() {
            const { data } = await ConfiguracaoSegmentosService.findAllByFiltro(
                this.getFiltros()
            );
            this.listaSegmentos = data.resultados;
            this.paginacao.total = data.totalResultados;
        },

        formatCpfCnpj(value) {
            if (!value || value.trim() === '') return '-';
            return formatters.numeralStringFormatTocpfCnpj(value);
        },
        mudarPagina(page) {
            this.pageable.page = page;
            this.buscarSegmentos();
        },
        goToCadastroSegmento() {
            this.$router.push({ name: 'CadastroSegmento' });
        }
    }
};
</script>

<style lang="scss">
.bloco-segmentos {
    margin: 20px;
}

.bloco-input {
    display: flex;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    @include default-box-shadow();
}

.bloco-input__icon i {
    color: $primary;
}

.bloco-input__input {
    flex: 1;

    input {
        border: 0 !important;
        outline: 0;
        width: 100%;
    }
}

.bloco-listagem-segmentos {
    margin-top: 20px;

    h3 {
        margin-bottom: 5px;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
        @include default-box-shadow();
    }
}

.bloco-lista-cpf-cnpj {
    margin-left: 20px;
    display: flex;
    flex-direction: column;

    label {
        font-weight: bold;
    }

    ul {
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;

        li {
            padding: 7px;
            border-top: 1px solid #f0f2f7;
            font-size: 12px;
        }
    }
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}
</style>
